import { useState, useEffect } from "react";
import debounce from 'lodash.debounce';

import { ImageLoading, getUrlForAssets } from "../../Contracts";

import styles from "./Thumbnail.module.scss";

export const Thumbnail = (props) => {

  const [windowWidth, setWindowWidth] = useState(0);

  const handleResizeEvent = debounce(() => {
    setWindowWidth(window.innerWidth);
  }, 200);

  useEffect(() => {
    setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResizeEvent);
    return () => {
      window.removeEventListener('resize', handleResizeEvent);
    };
  }, []);

  if (!props.imageUrl) {
    return null;
  }

  const getSize = (size) => {
    const defaultSize = { height: 64, width: 64 };
    if (!size) {
      size = defaultSize;
    }
    const height = size.height || defaultSize.height;
    const width = size.width || defaultSize.width;
    return { height, width };
  };

  const size = getSize((windowWidth < 600) ? (props.mobileSize ? props.mobileSize : props.size) : props.size);
  const style = props.style ? { ...props.style, ...size } : size;

  return (
    <img src={getUrlForAssets(props.imageUrl)} alt="thumbnail" id={props.id} className={`${styles.Thumbnail} ${props.rounded ? styles.ThumbnailRound : styles.ThumbnailSquare} ${props.className ? props.className : ''}`} style={style} loading={props.imageLoading === ImageLoading.EAGER ? ImageLoading.EAGER : ImageLoading.LAZY} height={props.imageHeight || "100%"} width={props.imageWidth || "100%"} />
  );

};

export default Thumbnail;
